export const DenominationTypes = {
    notes : 'notes',
    amount: 'amount'
}